/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1SsoimageQueryResponse,
  GetApiV1SsoimageQueryParams,
  GetApiV1Ssoimage400,
  GetApiV1Ssoimage401,
  GetApiV1Ssoimage500,
} from "../../types/SSOImageController/GetApiV1Ssoimage.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1Ssoimage } from "../../clients/SSOImageController/getApiV1Ssoimage.ts";

export const getApiV1SsoimageQueryKey = (
  params?: GetApiV1SsoimageQueryParams,
) => [{ url: "/api/v1/ssoimage" }, ...(params ? [params] : [])] as const;

export type GetApiV1SsoimageQueryKey = ReturnType<
  typeof getApiV1SsoimageQueryKey
>;

export function getApiV1SsoimageQueryOptions(
  params?: GetApiV1SsoimageQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1SsoimageQueryKey(params);
  return queryOptions<
    GetApiV1SsoimageQueryResponse,
    ResponseErrorConfig<
      GetApiV1Ssoimage400 | GetApiV1Ssoimage401 | GetApiV1Ssoimage500
    >,
    GetApiV1SsoimageQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1Ssoimage(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna todas as imagens e os idiomas ativos. **(Requer Authorization para autenticação)**
 * @summary Grid principal das imagens (Requer Authorization para autenticação)
 * {@link /api/v1/ssoimage}
 */
export function useGetApiV1Ssoimage<
  TData = GetApiV1SsoimageQueryResponse,
  TQueryData = GetApiV1SsoimageQueryResponse,
  TQueryKey extends QueryKey = GetApiV1SsoimageQueryKey,
>(
  params?: GetApiV1SsoimageQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1SsoimageQueryResponse,
        ResponseErrorConfig<
          GetApiV1Ssoimage400 | GetApiV1Ssoimage401 | GetApiV1Ssoimage500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getApiV1SsoimageQueryKey(params);

  const query = useQuery(
    {
      ...getApiV1SsoimageQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      GetApiV1Ssoimage400 | GetApiV1Ssoimage401 | GetApiV1Ssoimage500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
